import * as _ from "lodash";
import * as Constants from "../common/constants";
import { createWebServiceDataSource } from "../common/data";
import * as Global from "../common/global";
import * as GridUtil from "../common/gridFilter";
import * as UI from "../common/ui";
import { IApplication } from "../interfaces/application";
import { IController } from "../interfaces/controller";

// classes used to display a list of template forms

// parameters for filtering the list
interface ITargetTemplatesListFilter {
    SearchText?: string;
    IncludeActive: boolean;
    IncludeInactive: boolean;
}

export class TargetTemplatesController implements IController {
    // private properties

    // controls
    private grid: kendo.ui.Grid;
    private dataSource: kendo.data.DataSource;
    private gridFilterControl: GridUtil.GridFilterControl;

    // references to DOM elements
    private gridContainer: JQuery;

    // public methods

    // outputs the control to the HTML
    // returns a jQuery promise.
    public render(container: JQuery): JQueryPromise<any> {
        const me: TargetTemplatesController = this;
        const app: IApplication = Global.app();
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        me.gridContainer = container.find("div[data-id='grid']");

        // create the grid
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });

        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "Name", field: "TemplateName", template: kendo.template($("#template_targettemplates_templatename").html()) },
                { title: "Type", field: "TemplateTypeName" },
                {
                    title: "Last Modified", field: "DateTimeModified",
                    template: kendo.template($("#template_targettemplates_lastmodifieddate").html()),
                },
                { title: "Modified By", field: "ModifedByFullName" },
            ],
            excel: {
                fileName: "TargetTemplates.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");

        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showRefresh: true,
            showExportToExcel: true,
            showFilters: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });

        // bind to all link tags in the grid
        me.gridContainer.on("click", "a[data-id='link']", function(e: any): boolean {
            const path: string | undefined = $(this).attr("href");
            e.preventDefault();
            // open the page
            app.router().navigate(_.defaultTo<string>(path, ""), true);
            return false;
        });

        deferred.resolve();

        return deferred.promise();
    }

    // put data into this control.
    // call after rendering the control
    public load(params: any[]): JQueryPromise<any> {
        const app: IApplication = Global.app();
        const me: TargetTemplatesController = this;
        let dataSource: kendo.data.DataSource;
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        dataSource = createWebServiceDataSource(
            "/api/TargetTemplates",
            {
                id: "ID",
                fields: {
                    ID: { type: "long" },
                    TemplateName: { type: "string" },
                    URLFriendlyName: { type: "string" },
                    DateTimeModified: { type: "date" },
                    IsActive: { type: "boolean" },
                    TemplateTypeName: { type: "string" },
                    ModifedByFullName: { type: "string" },
                },
            },
            (data: any) => {
                me.setDataFilter(data);
            },
            (status: number) => {
                if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                    // user is not allowed to view this data, so close the page
                    app.pageManager().closeCurrentPage();
                }
                // for other errors, keep page open, allow user to retry.
            });

        // load data into the grid by calling a web service
        me.grid.setDataSource(dataSource);

        deferred.resolve();
        return deferred.promise();
    }

    public add(): void {
        Global.app().router().navigate("/TargetTemplate", true);
    }

    public haveFieldsChanged(): boolean {
        // no editable fields
        return false;
    }

    public height(height: number): void {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    }

    // called when loaded page is redisplayed
    public refresh(): void {
        this.grid.dataSource.read();
    }

    // returns a unique ID for the control, so it can be redisplayed if
    // already open.  Used by the AppRouter class.
    public appRouterID(params: string[]): string {
        return "TargetTemplates";
    }

    // returns a title for the page
    public title(): string {
        return "Target Templates";
    }

    public subTitle(): string {
        return "";
    }

    private setDataFilter(data: ITargetTemplatesListFilter): void {
        data.IncludeActive = true;
        data.IncludeInactive = false;

        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/targetTemplates.ts